import { useMemo } from 'react'

import { UserData } from 'types/entities'

import { CellProps, Badge } from 'components/ui'

import { Wrapper, Title, Value } from '../Style'

export function Status({ row }: CellProps<UserData>) {
  const { isVerifiedEmail } = row.original

  const value = useMemo(() => (isVerifiedEmail ? 'verified' : 'not_verified'), [isVerifiedEmail])
  return (
    <Wrapper area='Status'>
      <Title>Status</Title>
      <Value>
        <Badge value={value} />
      </Value>
    </Wrapper>
  )
}
